import { put } from 'redux-saga/effects';
import { replace } from 'react-router-redux';
// import * as ActionTypes from '../../actions/actionTypes';

export default function* logout(getFirebase) {
  try {
    yield getFirebase().logout();
    yield put(replace('/login'));
  } catch (err) {
    console.log('Error in saga!:', err);
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/auth/LogoutSaga.js